'use client';

import { Fragment } from 'react';
import { useBuyContext } from './state/BuyContext';
import {
  matchesVisibleWhen,
  type CardConfig,
  type ResolveCtx,
} from './state/cardSchema';
import { CardRenderer } from './CardRenderer';
import { Separator } from './atoms/Separator';

const isCardVisible = (card: CardConfig, ctx: ResolveCtx): boolean => {
  if (card.visibleWhen && !matchesVisibleWhen(card.visibleWhen, ctx.selections)) {
    return false;
  }
  if (card.show && !card.show(ctx)) {
    return false;
  }
  return true;
};

export type DataDrivenCardsProps = {
  cards?: CardConfig[];
};

export const DataDrivenCards = ({ cards: cardsProp }: DataDrivenCardsProps) => {
  const { cards: cardsCtx, resolveCtx } = useBuyContext();
  const cards = cardsProp ?? cardsCtx;

  const visible = cards.filter((card) => isCardVisible(card, resolveCtx));

  return (
    <>
      {visible.map((card, i) => (
        <Fragment key={card.id}>
          {i > 0 ? <Separator /> : null}
          <CardRenderer card={card} />
        </Fragment>
      ))}
    </>
  );
};
